/**
Project: Voice Panel (c)
Title: Filter Users 
Description: Component to dispay the user filter page.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React from "react";
import {
  Flex,
  Text,
  Button,
  Dialog,
  Divider,
  FormLabel,
  Dropdown,
} from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import IntlUtil from "../../../../core/helpers/intl-util";
import { getCommunicationPlatformByName } from "../actions/number-inventory-actions";
import { handleCommunicationPlatformName } from "../../common/actions/general-actions";

const NumberFilter = (props) => {
  return (
    <Dialog
      open={props.isFilterPanelOpen}
      className="vpa-dialog-Panel vpa-inv-dialog-Panel"
      header={
        <>
          <Text>
            {IntlUtil.getText(props.intlCommonNamespace, "content.filter")}
          </Text>
          <Divider size={1} />
        </>
      }
      content={
        <Grid fluid className="page-grid m-l-0 p-l-0">
          <Row>
            <Col
              xl={12}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="p-l-0"
            ></Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <div className="m-t-10">
                <FormLabel className="page-text text-semibold text-fc-dark">
                  {IntlUtil.getText(
                    props.intlNamespace,
                    "content.managedUNmanaged"
                  )}
                </FormLabel>
              </div>
              <div className="m-t-10">
                <Dropdown
                  inverted
                  id="selectedManagedStatus"
                  name="selectedManagedStatus"
                  className="vpa-dropdown"
                  highlightFirstItemOnOpen={true}
                  value={props.numberFilterSelectedData.selectedManagedStatus}
                  items={props.numbersRecords.managedRecords}
                  onChange={(e, option) => {
                    props.handleFormFieldFilter(option.id, option);
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <div className="m-t-10">
                <FormLabel className="page-text text-semibold text-fc-dark">
                  {IntlUtil.getText(props.intlNamespace, "content.Platform")}
                </FormLabel>
              </div>
              <div className="m-t-10">
                <Dropdown
                  inverted
                  id="selectedPlatForms"
                  name="selectedPlatForms"
                  multiple
                  className="vpa-dropdown"
                  highlightFirstItemOnOpen={true}
                  value={props.numberFilterSelectedData.selectedPlatForms}
                  items={props.numbersRecords.platFormRecords}
                  renderSelectedItem={(Item,prop)=>{
                    let header=handleCommunicationPlatformName(getCommunicationPlatformByName(props.communicationPlatformsData,prop.header));
                     return <Item {...prop} header={header}/>
                   }}
                  renderItem={(Item,prop)=>{
                   let header=handleCommunicationPlatformName(getCommunicationPlatformByName(props.communicationPlatformsData,prop.header));
                    return <Item {...prop} header={header}/>
                  }}
                  onChange={(e, option) => {
                    props.handleFormFieldFilter(option.id, option);
                  }}
                  getA11ySelectionMessage={{
                    onRemove: (item) => {
                      props.handleRemoveFilterItem("selectedPlatForms", item);
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="m-t-10">
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <div className="m-t-10">
                <FormLabel className="page-text text-semibold text-fc-dark">
                  {IntlUtil.getText(props.intlNamespace, "content.country")}
                </FormLabel>
              </div>
              <div className="m-t-10">
                <Dropdown
                  inverted
                  id="selectedCountries"
                  name="selectedCountries"
                  multiple
                  className="vpa-dropdown"
                  highlightFirstItemOnOpen={true}
                  value={props.numberFilterSelectedData.selectedCountries}
                  items={props.numbersRecords.countryRecords}
                  onChange={(e, option) => {
                    props.handleFormFieldFilter(option.id, option);
                  }}
                  getA11ySelectionMessage={{
                    onRemove: (item) => {
                      props.handleRemoveFilterItem("selectedCountries", item);
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="m-t-10">
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <div className="m-t-10">
                <FormLabel className="page-text text-semibold text-fc-dark">
                  {IntlUtil.getText(props.intlNamespace, "content.numberType")}
                </FormLabel>
              </div>
              <div className="m-t-10">
                <Dropdown
                  inverted
                  id="selectedNumberTypes"
                  name="selectedNumberTypes"
                  multiple
                  className="vpa-dropdown"
                  highlightFirstItemOnOpen={true}
                  value={props.numberFilterSelectedData.selectedNumberTypes}
                  items={props.numbersRecords.numberTypeRecords}
                  onChange={(e, option) => {
                    props.handleFormFieldFilter(option.id, option);
                  }}
                  getA11ySelectionMessage={{
                    onRemove: (item) => {
                      props.handleRemoveFilterItem("selectedNumberTypes", item);
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="m-t-10">
            <Col xl={12} lg={12} md={12} sm={12} xs={12}>
              <div className="m-t-10">
                <FormLabel className="page-text text-semibold text-fc-dark">
                  {IntlUtil.getText(props.intlNamespace, "content.carrier")}
                </FormLabel>
              </div>
              <div className="m-t-10">
                <Dropdown
                  inverted
                  id="selectedCarriers"
                  name="selectedCarriers"
                  multiple
                  className="vpa-dropdown"
                  highlightFirstItemOnOpen={true}
                  value={props.numberFilterSelectedData.selectedCarriers}
                  items={props.numbersRecords.carrierRecords}
                  onChange={(e, option) => {
                    props.handleFormFieldFilter(option.id, option);
                  }}
                  getA11ySelectionMessage={{
                    onRemove: (item) => {
                      props.handleRemoveFilterItem("selectedCarriers", item);
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
        </Grid>
      }
      footer={{
        children: () => {
          return (
            <Flex gap="gap.small">
              <Button
                className="vpa-usn-button-sm"
                onClick={props.handleFilterApply}
                primary
                content={IntlUtil.getText(
                  props.intlCommonNamespace,
                  "content.apply"
                )}
              />
              <Button
                onClick={props.handleFilterClear}
                content={IntlUtil.getText(
                  props.intlCommonNamespace,
                  "content.clear"
                )}
              />
              <Button
                onClick={props.handleFilterPanelClose}
                content={IntlUtil.getText(
                  props.intlCommonNamespace,
                  "content.close"
                )}
              />
            </Flex>
          );
        },
      }}
    />
  );
};

export default NumberFilter;
